import FilterPanel from "./FilterPanel";

export default FilterPanel;